import { useQuery } from "@tanstack/react-query";

import { FETCH_ERROR } from "../consts/fetch-error";
import { getMaintenancePlan, getMaintenancePlans } from "../services/maintenance-plan";

export function useGetMaintenancePlans() {
  return useQuery({
    queryKey: ["maintenancePlans"],
    queryFn: async () => await getMaintenancePlans(),
    staleTime: 1000 * 60 * 5,
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}

export function useGetMaintenancePlan(id: string) {
  return useQuery({
    queryKey: ["maintenancePlan", id],
    queryFn: () => getMaintenancePlan(id),
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}
